import React from 'react';
import c from '../w.js';

const IconChevronLeftLarge = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.41424 12.0001L15.7071 4.70718L14.2929 3.29297L5.58582 12.0001L14.2929 20.7072L15.7071 19.293L8.41424 12.0001Z"
      }
    )
  )
);

export { IconChevronLeftLarge };
